import { userHasRoles } from './services/role-service';
import { MatchLogic } from './components/ProtectedRoute/ProtectedRoute';
import { Role } from './constants/roles';

interface TabItem {
  title: string;
  index: number;
  requiredRoles: Role[];
  matchLogic: MatchLogic;
}

export const orderHub = [
  {
    title: 'Map',
    index: 0,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Commercial_Marketing,
      Role.Portal_Business_Viewer,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Order Details',
    index: 1,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Commercial_Marketing,
      Role.Portal_Business_Viewer,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Timetable',
    index: 2,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Availability',
    index: 3,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Devices',
    index: 4,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Custom',
    index: 5,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Ops_Admin,
      Role.Portal_Ops_MC,
      Role.Portal_Commercial_Admin,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  }
];

export const commercial = [
  {
    title: 'Notifications',
    index: 0,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Commercial_Marketing,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'App Display Products',
    index: 1,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Inventory',
    index: 2,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Special Offers',
    index: 3,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Commercial_Marketing,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Store Settings',
    index: 4,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'App Banners',
    index: 5,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Partners',
    index: 6,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  },
  {
    title: 'Automatic Notifications',
    index: 7,
    requiredRoles: [
      Role.Portal_Admin,
      Role.Portal_Commercial_Admin,
      Role.Portal_Commercial_CS,
      Role.Portal_Commercial_Marketing,
      Role.Portal_Dev_Admin
    ],
    matchLogic: MatchLogic.OR
  }
];

async function getTabConfig(page, includeHidden = false): Promise<TabItem[]> {
  let allTabItems: TabItem[] = [];
  if (page === 'OrderHub') {
    allTabItems = orderHub;
  } else if (page === 'Commercial') {
    allTabItems = commercial;
  }

  const allowedTabItems = [];

  for (let i = 0; i < allTabItems.length; i++) {
    // Skip Custom tab unless explicitly requested
    if (allTabItems[i].title === 'Custom' && !includeHidden) {
      continue;
    }
    
    const isAllowed = await userHasRoles(
      allTabItems[i].requiredRoles,
      allTabItems[i].matchLogic
    );
    if (isAllowed) {
      allowedTabItems.push(allTabItems[i]);
    }
  }
  return allowedTabItems;
}

export default getTabConfig;
